import React from 'react'

const IconButton = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <rect
                x='1.5'
                y='2.91'
                width='13'
                height='6.5'
                rx='1.3'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.43 5.73L8.43 12.23L9.95 10.71L11.03 13.09L12.12 12.66L11.03 10.28L13.2 10.28L8.43 5.73Z'
                fill='white'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default IconButton
